var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v("Telephone")])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_vm._v("\n    01706 750 293\n  ")])])
}]

export { render, staticRenderFns }